import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Demo() {
  const { demoLogin } = useAuth();
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        await demoLogin();
        toast.success("Welcome to the GreenBelt investor preview");
        // Hard navigation (not SPA nav) so the auth cookie is in place before
        // ProtectedRoute re-runs — avoids a race where setUser is batched and
        // ProtectedRoute bounces to /login.
        window.location.assign("/portfolio");
      } catch {
        toast.error("Demo preview is currently unavailable. Please try again.");
        nav("/", { replace: true });
      }
    })();
  }, [demoLogin, nav]);

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center">
      <div className="text-center" data-testid="demo-loading">
        <div className="label-tag text-ink2 mb-3">investor preview</div>
        <div className="font-serif text-3xl text-ink">Loading demo workspace…</div>
        <div className="mt-4 h-1 w-40 mx-auto bg-line overflow-hidden">
          <div className="h-full w-1/3 bg-leaf animate-[loader_1.2s_ease-in-out_infinite]"></div>
        </div>
        <style>{`@keyframes loader { 0% { transform: translateX(-100%);} 100% { transform: translateX(300%);} }`}</style>
      </div>
    </div>
  );
}
